module.exports = __webpack_public_path__ + "static/media/music-screenshot-beliebers.bf322b63.png";